import * as React from "react";
import {connect} from "react-redux";
import {RootState} from "../../../../store/reducer/root/RootState";
import User from "../../../../model/user/User";
import {Icon} from "../../../../hiberUiKit/src/atoms/Icon/Icon";
import DropDownWrapper from "../../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import SearchDropDown from "../../../../hiberUiKit/src/molecules/SearchDropDown/SearchDropDown";
import TextDropDownWrapper from "../../../../hiberUiKit/src/molecules/TextDropDownWrapper/TextDropDownWrapper";
import {Option} from "ts-option";

interface IComponentProps {
	/**
	 * Selected agent id.
	 */
	agentId: Option<string>;
	/**
	 * Agent change callback.
	 * @param {User} user
	 */
	onChange?: (user: User) => void;
	/**
	 * Indicate if selection is removable (shows "x" button).
	 */
	removable?: boolean;
	/**
	 * On delete icon click callback. Remove selection.
	 * @param {React.MouseEvent<HTMLSpanElement>} evt
	 */
	onRemoveClick?: (evt: React.MouseEvent<HTMLSpanElement>) => void;
	/**
	 * Custom role title
	 */
	customRoleTitle?: string;
}

interface IReduxProps {
	/**
	 * All not disabled users with "agent" role.
	 */
	agents: User[]
}

interface IState {
	/**
	 * Indicates if select agent dropdown is visible.
	 */
	dropDownVisible: boolean;
}

type Props = IComponentProps & IReduxProps;

class AgentSelector extends React.PureComponent<Props, IState> {
	public static defaultProps: Partial<Props> = {
		customRoleTitle: "Agent"
	};

	constructor(props: Props) {
		super(props);
		this.state = {dropDownVisible: false};
		this.toggleDropdown = this.toggleDropdown.bind(this);
		this.onSelect = this.onSelect.bind(this);
	}

	render() {
		let agents: User[] = this.props.agents.filter(a => !a.disabled);
		const selectedAgent: User = this.props.agentId.map(aId => {
			agents = agents.filter(a => a.id != aId);
			return this.props.agents.filter(a => a.id == aId)[0]
		}).orNull;
		const agentTxt = `${this.props.customRoleTitle}: ${selectedAgent ? selectedAgent.getDisplayName(true) : "Unassigned"}`;
		return (
			<TextDropDownWrapper text={agentTxt}
								 onClick={this.toggleDropdown}
								 onRemoveClick={this.props.onRemoveClick}
								 removable={this.props.removable}>
				{this.state.dropDownVisible &&
				<DropDownWrapper onOutsideClick={() => {this.setState({dropDownVisible: false})}}>
					<SearchDropDown items={agents}
									onChange={this.onSelect}
									itemToLabel={(user: User) => user.getDisplayName()}
									itemToId={(user: User) => user.id}
									searchInputIcon={Icon.User}/>
				</DropDownWrapper>
				}
			</TextDropDownWrapper>
		);
	}

	toggleDropdown() {
		this.setState({dropDownVisible: !this.state.dropDownVisible});
	}

	onSelect(user: User) {
		this.toggleDropdown();
		this.props.onChange(user);
	}
}

function mapStateToProps(state: RootState) {
	return {
		agents: state.user.users.getOrElse([]).filter(u => u.isAgent())
	}
}

export default connect<IReduxProps, null, IComponentProps>(mapStateToProps, null)(AgentSelector)